module.exports = __webpack_public_path__ + "static/media/driverIcon.35c84e7c.jpeg";